import React from 'react';
import ENUMS from '../../enums';
import { connect } from 'react-redux';
import { formatter } from '../../utils';
import * as menuCategoriesActions from '../../redux/menuCategories/actions';
import Pagination2 from '../../components/Pagination2';
import Spin from '../../components/loading';

class MenuCategoriesDeleteds extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      itemsPerPage: 10
    };
  }

  componentDidMount() {
    this.props.fetchAllDeletedMenuCategories(
      `pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`
    );
  }

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllDeletedMenuCategories(query);
    });
  };

  render() {
    let { deletedMenuCategoriesList = [], loading, error, message, failed } = this.props;
    let { totalRecords } = this.props.deletedMenuCategories;
    let { currentPage, itemsPerPage } = this.state;
    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">{locales('titles.deleteMenuCategories')}</h3>
          <div>
            <button
              onClick={() => this.props.history.push('/menu-categories')}
              className="btn btn-default w-5 mx-1"
            >
              <i className="fa fa-reply" />
              {locales('labels.cancel')}
            </button>
          </div>
        </div>

        <main className="panel panel-default">
          <div className="panel-heading">
            <i className="fas fa-list-alt px-1" />
            {locales('titles.menuCategoriesDeletedsList')}
          </div>
          <div className="panel-body">
            <Spin spinning={loading}>
              {error && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
              {failed && <div className="alert alert-danger">{message}</div>}
              <table className="table table-hover table-light table-striped">
                <thead>
                  <tr>
                    <th className="text-center">{locales('tables.row')}</th>
                    <th className="text-center ">{locales('tables.title')}</th>
                    <th className="text-center ">{locales('tables.displayOrder')}</th>
                    <th className="text-center">{locales('tables.activated')}</th>
                    <th className="text-center">{locales('tables.deleter')}</th>
                    <th className="text-center">{locales('tables.deletationDate')}</th>
                  </tr>
                </thead>
                <tbody>
                  {deletedMenuCategoriesList.length ? (
                    deletedMenuCategoriesList.map((menuCategory, index) => (
                      <tr key={menuCategory.id}>
                        <td className="text-center">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td className="text-center">{menuCategory.title}</td>
                        <td className="text-center">{menuCategory.displayOrder || '---'}</td>
                        <td className="text-center">
                          <i
                            className={`${
                              menuCategory.isActive
                                ? 'fal fa-check-square text-success'
                                : 'fal fa-times-square text-danger'
                            }`}
                          />
                        </td>
                        <td className="text-center">{menuCategory.deletedFullName}</td>
                        <td className="text-center">{menuCategory.deletedAt}</td>
                      </tr>
                    ))
                  ) : (
                    <tr className="col-12 text-center">
                      <td className="alert alert-info" colSpan={12}>
                        {locales('alerts.noRecord')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Spin>
          </div>
        </main>
        <footer className="col-12 d-flex justify-content-center py-2">
          <div className="pagination-container">
            <Pagination2
              totalRecords={totalRecords || 0}
              pageLimit={itemsPerPage}
              pageNeighbours={2}
              onPageChanged={this.onPageChanged}
              currentPage={this.currentPage}
            />
          </div>
        </footer>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    deletedMenuCategoriesList: state.menuCategoriesReducer.deletedMenuCategoriesList,
    loading: state.menuCategoriesReducer.deletedMenuCategoriesLoading,
    message: state.menuCategoriesReducer.deletedMenuCategoriesMessage,
    failed: state.menuCategoriesReducer.deletedMenuCategoriesFailed,
    error: state.menuCategoriesReducer.deletedMenuCategoriesError,
    deletedMenuCategories: state.menuCategoriesReducer.deletedMenuCategories
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllDeletedMenuCategories: query =>
      dispatch(menuCategoriesActions.fetchAllDeletedMenuCategories(query))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuCategoriesDeleteds);
